import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL, CLAIM_CLIENT_URL } from '../../config';
// @mui/material components
// core components
import GridItem from '@/components/Grid/GridItem';
import GridContainer from '@/components/Grid/GridContainer';
// import Table from "components/Table/Table";
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';

import loader from '../../assets/img/loader.svg';

// components for table.
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Button from '@/components/CustomButtons/Button';
import { ArrowDownward, ArrowUpward, LinkRounded } from '@mui/icons-material';
import { Base64 } from 'js-base64';
import { toast } from 'react-toastify';
import { Box, Modal } from '@mui/material';
import { modalStyle } from '@/views/Clients/Claim';
import CustomInput from '@/components/CustomInput/CustomInput';
import { getBusinessUnitsForForm } from '@/api/clients/business-units/business-units.api';
import TablePaginationActions from '@/views/Managefile/TablePaginationActions/TablePaginationActions';
import { checkOrganizationFeatures, ORGANIZATION_FEATURES } from '@/utility';
import FacilitySelect from '@/components/FacilitySelect';

//const useStyles = makeStyles(styles);

export default function UnclaimedRefunds() {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [sortBy, setSortBy] = useState({ name: 'created_at', order: -1 });
  const [payments, setPayments] = useState([]);
  const [sortedPayments, setSortedPayments] = useState([]);
  const [updateEmailOfRefund, setUpdateEmailOfRefund] = useState(null);
  const [updatedEmail, setUpdatedEmail] = useState('');
  const [modalErr, setModalErr] = useState('');

  const [businessUnits, setBusinessUnits] = useState([]);
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState('');
  const [selectedFacility, setSelectedFacility] = useState('');

  useEffect(() => {
    const fetchRefunds = async () => {
      try {
        setLoaded(true);

        const formData = new FormData();
        formData.append('startDate', startDate);
        formData.append('endDate', endDate);
        formData.append('business_unit_id', selectedBusinessUnit);
        formData.append('facility_id', selectedFacility);
        setPayments(
          (
            await axios.post(API_BASE_URL + '/unclaimed-refunds', formData)
          ).data.map((payment) => ({
            ...payment,
            refund_amount: +payment.refund_amount,
          })),
        );
        setLoaded(false);
      } catch (error) {
        setLoaded(false);
        console.log(error);
      }
    };

    fetchRefunds();
  }, [startDate, endDate, selectedBusinessUnit, selectedFacility]);

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      setBusinessUnits(await getBusinessUnitsForForm());
    };

    fetchBusinessUnits();
  }, []);

  const getRefunds = async () => {
    try {
      setLoaded(true);

      const formData = new FormData();
      formData.append('startDate', startDate);
      formData.append('endDate', endDate);
      formData.append('business_unit_id', selectedBusinessUnit);
      formData.append('facility_id', selectedFacility);
      setPayments(
        (
          await axios.post(API_BASE_URL + '/unclaimed-refunds', formData)
        ).data.map((payment) => ({
          ...payment,
          refund_amount: +payment.refund_amount,
        })),
      );
      setLoaded(false);
    } catch (error) {
      setLoaded(false);

      console.log(error);
    }
  };

  /*** Change start date */
  const changeDate = (event) => {
    setStartDate(event ?? '');
  };

  /*** Change end date */
  const changeEndDate = (event) => {
    setEndDate(event ?? '');
  };

  useEffect(() => {
    getRefunds();
  }, [startDate, endDate, selectedBusinessUnit]);

  // functions for pagination.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    console.log(sortBy.order, sortBy.name);
    const array = [...payments];

    const sortedArray = array.sort((payment1, payment2) => {
      if (payment1[sortBy.name] < payment2[sortBy.name]) {
        return -1;
      }
      if (payment1[sortBy.name] > payment2[sortBy.name]) {
        return 1;
      }
      return 0;
    });
    setSortedPayments(
      sortBy.order === 1
        ? sortedArray
        : sortBy.order === -1
        ? sortedArray.reverse()
        : [...payments],
    );
  }, [payments, sortBy.order, sortBy.name]);

  const sortByColumn = (columnName) => {
    setSortBy({
      name: columnName,
      order:
        sortBy.name === columnName
          ? sortBy.order === 1
            ? -1
            : sortBy.order === -1
            ? 1
            : sortBy.order === 0
            ? 1
            : 1
          : 1,
    });
  };

  const sortArrow = (columnName) => {
    // console.log(sortBy.order);
    return columnName === sortBy.name ? (
      sortBy.order === 1 ? (
        <ArrowDownward fontSize='small' />
      ) : sortBy.order === -1 ? (
        <ArrowUpward fontSize='small' />
      ) : sortBy.order === 0 ? (
        ''
      ) : (
        ''
      )
    ) : (
      ''
    );
  };

  const copyLinkToClipBoard = (id) => {
    const encodedId = Base64.encode(id);
    navigator.clipboard.writeText(CLAIM_CLIENT_URL + '/payments/' + encodedId);
    toast.success(t('unclaimedRefunds.messages.copiedToClipboard'), {
      autoClose: 1000,
    });
  };

  const updateEmail = (e, editEmail) => {
    e.preventDefault();

    if (!editEmail) {
      return setModalErr(t('unclaimedRefunds.modal.noEmailProvided'));
    }
    const formData = new FormData();
    formData.append('email', updatedEmail.toLowerCase());
    formData.append('id', editEmail);
    formData.append('zipCode', localStorage.getItem('zipCode'));
    axios
      .post(API_BASE_URL + '/updaterefundEmail/' + editEmail, formData)
      .then(() => {
        setUpdateEmailOfRefund(null);
        getRefunds();
        setUpdatedEmail('');
      })
      .catch((err) => {
        setModalErr(err.response?.data?.message);
      });
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color='primary'>
            <h4>{t('unclaimedRefunds.title')}</h4>
          </CardHeader>

          <CardBody>
            <div>
              {loaded && (
                <div className='loaders'>
                  <img src={loader} />
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '16px',
                  alignItems: 'center',
                  marginBottom: '20px',
                }}>
                <div>
                  {t('unclaimedRefunds.dateFilters.fromLabel')}&nbsp;&nbsp;
                  <DatePicker
                    className='full-width-elem-date-picker'
                    id='dt'
                    autoComplete='off'
                    selected={startDate}
                    onChange={changeDate}
                  />
                </div>
                <div>
                  {t('unclaimedRefunds.dateFilters.toLabel')}&nbsp;&nbsp;
                  <DatePicker
                    className='full-width-elem-date-picker'
                    id='dt'
                    autoComplete='off'
                    selected={endDate}
                    onChange={changeEndDate}
                  />
                </div>
                {checkOrganizationFeatures(
                  ORGANIZATION_FEATURES.showBusinessUnitsPage,
                ) && (
                  <div>
                    <select
                      id='status'
                      className='full-width-elem'
                      onChange={(e) => setSelectedBusinessUnit(e.target.value)}>
                      <option value={''}>
                        {t('unclaimedRefunds.filters.businessUnitPlaceholder')}
                      </option>
                      {businessUnits.map((obj) => (
                        <option value={obj.id} key={obj.id}>
                          {obj.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <FacilitySelect
                  value={selectedFacility}
                  onChange={setSelectedFacility}
                  parentKey='unclaimed_refunds'
                  childKey='unclaimed_refunds'
                  permission='read'
                />
              </div>
              <Table width='100%' id='template'>
                <TableHead>
                  <TableRow style={{ cursor: 'pointer', userSelect: 'none' }}>
                    <TableCell
                      width='15%'
                      onClick={() => sortByColumn('email_sent_date')}>
                      {t('unclaimedRefunds.table.emailSentDate')}{' '}
                      {sortArrow('email_sent_date')}
                    </TableCell>
                    <TableCell
                      width='30%'
                      onClick={() => sortByColumn('last_name')}>
                      {t('unclaimedRefunds.table.customer')}{' '}
                      {sortArrow('last_name')}
                    </TableCell>
                    <TableCell
                      onClick={() => sortByColumn('business_unit_name')}>
                      {t('unclaimedRefunds.table.businessUnit')}{' '}
                      {sortArrow('business_unit_name')}
                    </TableCell>
                    <TableCell onClick={() => sortByColumn('facility_name')}>
                      {t('common.facility')} {sortArrow('facility_name')}
                    </TableCell>
                    <TableCell onClick={() => sortByColumn('refund_amount')}>
                      {t('unclaimedRefunds.table.amount')}{' '}
                      {sortArrow('refund_amount')}
                    </TableCell>
                    <TableCell onClick={() => sortByColumn('email_sent')}>
                      {t('unclaimedRefunds.table.numberOfEmailsSent')}{' '}
                      {sortArrow('email_sent')}
                    </TableCell>
                    <TableCell onClick={() => sortByColumn('refund_status')}>
                      {t('unclaimedRefunds.table.paymentStatus')}{' '}
                      {sortArrow('refund_status')}
                    </TableCell>
                    <TableCell
                    // onClick={() => sortByColumn('refund_status')}
                    >
                      {t('unclaimedRefunds.table.refundLink')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                {sortedPayments && sortedPayments.length > 0 ? (
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedPayments.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : sortedPayments
                    ).map((obj, index) => (
                      <TableRow className='txtalign' key={index}>
                        <TableCell>
                          {obj.email_sent_date
                            ? moment(obj.email_sent_date).format('MM/DD/YYYY')
                            : t('unclaimedRefunds.table.notApplicable')}
                        </TableCell>
                        <TableCell>
                          {obj.first_name} {obj.last_name}
                          <p style={{ fontSize: '12px' }}>
                            {!obj.email ? (
                              t('unclaimedRefunds.table.notApplicable')
                            ) : (
                              <span style={{ display: 'flex' }}>
                                <p style={{ fontSize: '12px' }}>{obj.email}</p>
                                {/* <EditRounded
                                  style={{ cursor: 'pointer' }}
                                  fontSize='small'
                                  onClick={() => {
                                    setUpdateEmailOfRefund(obj);
                                  }}
                                /> */}
                              </span>
                            )}
                          </p>
                        </TableCell>
                        <TableCell>{obj.business_unit_name}</TableCell>
                        <TableCell>
                          {obj.facility_name ||
                            t('unclaimedRefunds.table.notApplicable')}
                        </TableCell>
                        <TableCell>
                          {parseFloat(obj && obj.refund_amount).toLocaleString(
                            undefined,
                            {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            },
                          )}
                        </TableCell>
                        <TableCell>{obj.email_sent}</TableCell>
                        <TableCell>
                          {obj.refund_status ??
                            t('unclaimedRefunds.table.statusPending')}
                        </TableCell>
                        <TableCell onClick={() => copyLinkToClipBoard(obj.id)}>
                          <a>
                            <LinkRounded />
                          </a>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        {t('unclaimedRefunds.table.noTransactionData')}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        {
                          label: t('unclaimedRefunds.pagination.all'),
                          value: -1,
                        },
                      ]}
                      colSpan={2}
                      count={payments.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          'aria-label': t(
                            'unclaimedRefunds.pagination.rowsPerPage',
                          ),
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </CardBody>
        </Card>
      </GridItem>
      <Modal
        open={updateEmailOfRefund ? true : false}
        onClose={() => setUpdateEmailOfRefund(null)}>
        <form onSubmit={(e) => updateEmail(e, updateEmailOfRefund?.id)}>
          <Box
            sx={modalStyle}
            className='makeStyles-card-96'
            noValidate
            autoComplete='off'>
            <CardHeader
              style={{ transform: 'translateY(-50%)' }}
              color='primary'>
              <h4>{t('unclaimedRefunds.modal.title')}</h4>
            </CardHeader>
            <CardBody style={{ marginTop: '-20px' }}>
              {modalErr && (
                <p
                  style={{
                    color: 'red',
                    padding: '0',
                    margin: 0,
                    fontSize: '15px',
                  }}>
                  {modalErr}
                </p>
              )}
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    type='email'
                    labelText={t('unclaimedRefunds.modal.currentEmail')}
                    value={updateEmailOfRefund?.email}
                    autoComplete='off'
                    disabled
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    type='email'
                    labelText={t('unclaimedRefunds.modal.newEmail')}
                    onChange={(e) => setUpdatedEmail(e.target.value)}
                    value={updatedEmail}
                    autoComplete='off'
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <div>
                <Button variant='contained' color='primary' type='submit'>
                  {t('unclaimedRefunds.modal.updateButton')}
                </Button>
              </div>
            </CardBody>
          </Box>
        </form>
      </Modal>
    </GridContainer>
  );
}
